// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--2GEMf","leftLogo":"header-module--leftLogo--1OwZt","rightLogo":"header-module--rightLogo--2QE1r"};